<footer><p>Copyright Soundhacker 2020. All rights reserved.</p>
</footer>